import React from 'react'

import ImageGallery from 'react-image-gallery'
import '../../../node_modules/react-image-gallery/styles/scss/image-gallery.scss'
import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css'

import {upaltino, vitralaltino, atriobelavista, portalvistallegro, parquecentralreserva, boulevardparquecentral, questcampesina, nogallery} from '../../const/data'

function selectGallery(item){

    switch(item){
        case 'upaltino': return upaltino;
        case 'vitralaltino': return vitralaltino;
        case 'atriobelavista': return atriobelavista;
        case 'portalvistallegro': return portalvistallegro;
        case 'parquecentralreserva': return parquecentralreserva;
        case 'boulevardparquecentral': return boulevardparquecentral;
        case 'questcampesina': return questcampesina;

        default: return nogallery;

    }
}


export default class GalleryComponent extends React.Component {

    constructor(props){
        super(props);
        this.index = this.props.gallery_item;
    }

    render(){

        return(
            <ImageGallery items={selectGallery(this.index)} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Components/GalleryComponent.jsx